import { render, staticRenderFns } from "./DownloadBtnWithProgress.vue?vue&type=template&id=ebf70f5e"
import script from "./DownloadBtnWithProgress.vue?vue&type=script&lang=js"
export * from "./DownloadBtnWithProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports